<template>
  <div>
    <div v-if="schema.is_part_time_worker">
      <div class="mx-3">{{ $t('monthTarget') }}: {{ monthTarget }}</div>

      <v-layout row>
        <v-text-field
          v-model="actualWorkedHours"
          :label="$t('workedHoursSum')"
          class="mx-3"
          type="number"
        />
        <v-btn
          class="mx-3"
          color="primary"
          @click="allocateHoursFromBackend">{{ $t('calculateHours') }}
        </v-btn>
      </v-layout>
    </div>
    <v-data-table
      :headers="headers"
      :items="timesheet"
      :loading="isLoading"
      :hide-actions="true"
      :disable-initial-sort="true">

      <template
        slot="items"
        slot-scope="{item}">
        <employee-timesheet-editor-table-day
          :day="item"
          :schema="schema"
          :mean-value-work-time="meanValueWorkTime"
        />
      </template>
      <template
        v-if="schema.is_part_time_worker"
        slot="footer">
        <td><strong>Summe:</strong></td>
        <td/>
        <td class="text-xs-left"> {{ workedHoursSum }}</td>
        <td/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import timesheetApi from '@/api/TimesheetApi'
import EmployeeTimesheetEditorTableDay from '@/components/routes/employees/timesheets/EmployeeTimesheetEditorTableDay'

export default {
  name: 'EmployeeTimesheetEditorTable',
  components: { EmployeeTimesheetEditorTableDay },
  props: ['timesheet', 'isLoading', 'isCreating', 'schema', 'month'],
  data () {
    return {
      actualWorkedHours: 0,
      initialTimesheet: null,
      headers: [
        { text: this.$t('date'), value: 'YYYY-MM-DD', sortable: false },
        { text: this.$t('workingTime'), value: 'HH:MM', sortable: false },
        { text: this.$t('workedHours'), value: this.$t('hours'), sortable: false },
        { text: '', sortable: false, align: 'right' }
      ]
    }
  },
  computed: {
    meanValueWorkTime () {
      const workedDays = this.timesheet.filter(el => el.worked_hours > 0)
      if (workedDays.length === 0) {
        return 0
      }
      return workedDays.reduce((carry, current) => {
        return carry + current.worked_hours
      }, 0) / workedDays.length
    },
    monthTarget () {
      const possibleWorkDays = this.timesheet.filter(el => el.is_allowed_to_work).length
      return Math.floor(this.schema.hours_week / 7 * possibleWorkDays)
    },

    workedHoursSum () {
      return Math.ceil(this.timesheet.reduce((sum, day) => sum + day.worked_hours, 0))
    }
  },
  methods: {
    async allocateHoursFromBackend () {
      try {
        const hours = this.actualWorkedHours
        const schema_id = this.schema.id
        const month = this.month
        const ignore_last_6_days = `${this.$route.query.ignore_last_6_days}` === 'true'
        const days = await timesheetApi.allocateHoursForPartTimeWorker(month, schema_id, hours, ignore_last_6_days)
        while (this.timesheet.length) {
          this.timesheet.pop()
        }
        days.forEach((newDay) => {
          newDay.changed_ex_post = false
          this.timesheet.push(newDay)
        })
      } catch (e) {
        this.$notification(e)
      }
    }

  },
  watch: {
    timesheet (val) {
      if (this.initialTimesheet === null) {
        this.initialTimesheet = val
      }
    }
  },
  i18n: {
    messages: {
      de: {
        date: 'Datum',
        holiday: 'Feiertag',
        hours: 'Std. ',
        selectedMonth: 'Gewählter Monat',
        workedHours: 'Gearbeitete Stunden',
        workingTime: 'Arbeitszeit',
        monthTarget: 'Soll-Stunden',
        workedHoursSum: 'Ist-Stunden',
        calculateHours: 'Stunden umlegen'
      },
      en: {
        date: 'Date',
        holiday: 'Holiday',
        hours: 'h',
        selectedMonth: 'Monat',
        workedHours: 'Worked hours',
        workingTime: 'Working time',
        monthTarget: 'Target hours',
        workedHoursSum: 'Actual hours',
        calculateHours: 'Allocate hours'
      },
      tr: {
        date: 'Tarih',
        holiday: 'Tatil',
        hours: 's',
        selectedMonth: 'Ay',
        workedHours: 'Çalışma saati',
        workingTime: 'Çalışma süresi',
        monthTarget: 'Hedef saatleri',
        workedHoursSum: 'Fiili saat',
        calculateHours: 'Saati ayır'
      },
      ru: {
        date: 'Дата',
        holiday: 'Выходной',
        hours: 'ч',
        selectedMonth: 'День',
        workedHours: 'Отработанные часы',
        workingTime: 'Рабочее время',
        monthTarget: 'Целевые часы',
        workedHoursSum: 'Фактические часы',
        calculateHours: 'Выделить часы'
      }
    }
  }
}
</script>

<style scoped>

</style>
